import { render } from "./AssistantTeacherSubmission.vue?vue&type=template&id=1120d04e&scoped=true"
import script from "./AssistantTeacherSubmission.vue?vue&type=script&lang=js"
export * from "./AssistantTeacherSubmission.vue?vue&type=script&lang=js"

import "./AssistantTeacherSubmission.vue?vue&type=style&index=0&id=1120d04e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1120d04e"]])

export default __exports__